import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'

export type GtmCheckoutAccountDataAddedProps = {
  scenario: 'login' | 'signup' | 'prefilled_for_logged_in_user'
}

export const gtmCheckoutAccountDataAdded = ({
  scenario,
}: GtmGlobalStoreProps & GtmCheckoutAccountDataAddedProps) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_checkout_account_data_added',
    event_id: uuid,
    scenario,
  })
}
